var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoziePurpleBlueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 44,
    viewBox: "0 0 236 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Rozie-PurpleBlue-Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M68.438 32.1413V9.14127H79.3824C80.7958 9.12771 82.189 9.46037 83.4281 10.1073C84.6353 10.7211 85.6523 11.6251 86.3778 12.7293C87.1438 13.8623 87.5418 15.1849 87.5222 16.5319C87.5235 17.9114 87.0477 19.2531 86.1682 20.3499C85.2647 21.5226 84.0293 22.4266 82.6061 22.9566L88.6021 32.1566H83.7666L78.3347 23.5239H72.4354V32.1566L68.438 32.1413ZM72.4031 20.0893H79.7209C80.2163 20.1028 80.7091 20.017 81.1674 19.8373C81.6256 19.6577 82.0389 19.3883 82.3804 19.0466C82.7285 18.7002 83.0004 18.2913 83.1803 17.8437C83.3602 17.3961 83.4445 16.9189 83.4281 16.4399C83.4452 15.9083 83.3334 15.3801 83.1014 14.8961C82.8694 14.4122 82.5235 13.9856 82.0903 13.6493C81.1378 12.91 79.9337 12.5281 78.7054 12.5759H72.4354L72.4031 20.0893Z",
    fill: "#241032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M109.137 32.4787C107.421 32.4915 105.719 32.1895 104.124 31.5894C102.633 31.0184 101.275 30.1744 100.127 29.1054C98.9725 28.0477 98.0614 26.7737 97.4511 25.364C96.814 23.8695 96.4961 22.2693 96.5162 20.6567C96.4944 19.039 96.8123 17.4334 97.4511 15.934C98.056 14.5291 98.9554 13.2561 100.094 12.1927C101.243 11.1236 102.601 10.2796 104.092 9.70869C107.318 8.52321 110.892 8.52321 114.117 9.70869C115.608 10.287 116.966 11.1359 118.115 12.208C119.246 13.2839 120.144 14.5601 120.758 15.9647C122.004 18.9751 122.004 22.3229 120.758 25.3334C120.144 26.7379 119.246 28.0142 118.115 29.09C116.966 30.1621 115.608 31.0111 114.117 31.5894C112.532 32.1846 110.841 32.4864 109.137 32.4787ZM109.137 29.0287C110.691 29.0546 112.223 28.6783 113.569 27.94C114.863 27.2051 115.918 26.1437 116.616 24.8734C117.364 23.5562 117.742 22.0771 117.712 20.58C117.744 19.0778 117.366 17.5934 116.616 16.2714C115.918 15.0011 114.863 13.9396 113.569 13.2047C112.219 12.4904 110.699 12.1156 109.153 12.1156C107.607 12.1156 106.087 12.4904 104.737 13.2047C103.467 13.9183 102.425 14.9464 101.722 16.1794C100.963 17.5042 100.579 18.9946 100.61 20.5034C100.582 22.0071 100.965 23.492 101.722 24.812C102.425 26.045 103.467 27.0731 104.737 27.7867C106.058 28.572 107.579 29.0012 109.137 29.0287Z",
    fill: "#241032"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M130.107 32.1412V29.5498L144.275 12.5758H131.058V9.15649H149.675V11.7172L135.571 28.7985H150.078V32.2025L130.107 32.1412Z",
    fill: "#241032"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M161.231 32.1412V28.7985H165.39V12.4378H161.231V9.15649H173.498V12.4378H169.339V28.7985H173.498V32.0798L161.231 32.1412Z",
    fill: "#241032"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M185.554 32.1414V9.14136H201.673V12.5607H189.455V18.694H199.658V22.1134H189.455V28.7987H201.673V32.2027L185.554 32.1414Z",
    fill: "#241032"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M213.02 21.2085L218.339 9.15649H220.66L225.883 21.2085H223.175L222.014 18.4332H216.727L215.551 21.2085H213.02ZM218.339 14.3852L217.485 16.5318H221.257L220.338 14.3545L220.096 13.7105C219.983 13.4192 219.87 13.0972 219.741 12.7445L219.387 11.7632C219.242 12.2078 219.064 12.6678 218.887 13.1585C218.71 13.6492 218.533 14.0478 218.339 14.3852Z",
    fill: "#241032"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M229.058 21.2085V19.2305H231.234V11.1345H229.042V9.15649H235.941V11.1345H233.716V19.2305H235.941V21.2085H229.058Z",
    fill: "#241032"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M46.3073 32.8619C45.8681 34.3414 44.9329 35.6439 43.6439 36.5711C42.3549 37.4984 40.7828 37.9996 39.1668 37.9986C38.5693 38.0031 37.9736 37.9362 37.3938 37.7992C36.4252 37.6062 35.519 37.1962 34.7503 36.6032C34.0505 36.1057 33.45 35.4929 32.9773 34.7939L32.5905 34.2572L28.5609 28.2006C27.8073 26.8358 26.7677 25.6324 25.5064 24.6646C24.2451 23.6967 22.7886 22.985 21.227 22.5732C18.5816 23.4205 15.7547 23.6209 13.0066 23.1559L21.0658 36.3119C27.8355 47.0452 46.001 45.3892 46.4523 32.4939C46.4108 32.6189 46.3624 32.7417 46.3073 32.8619Z",
    fill: "#844D9E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M46.3072 32.8619C45.8681 34.3414 44.9329 35.6439 43.6439 36.5711C42.3549 37.4984 40.7828 37.9996 39.1668 37.9986C38.5693 38.0031 37.9736 37.9362 37.3938 37.7992C36.4252 37.6062 35.519 37.1962 34.7503 36.6032C34.0505 36.1057 33.45 35.4929 32.9773 34.7939L32.5905 34.2572L28.5609 28.2006C27.8073 26.8358 26.7677 25.6324 25.5064 24.6646C24.2451 23.6967 22.7886 22.985 21.227 22.5732C18.5816 23.4205 15.7547 23.6209 13.0066 23.1559L21.0658 36.3119C27.8355 47.0452 46.001 45.3892 46.4523 32.4939C46.4108 32.6189 46.3623 32.7417 46.3072 32.8619Z",
    fill: "url(#paint0_linear_3411_2017)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M0.12793 7.68471V25.9314C0.12793 32.724 7.12333 35.4074 11.2335 35.4074V5.79871C9.99522 5.38811 8.69257 5.18072 7.38122 5.18537C4.72694 5.16585 2.15334 6.05266 0.12793 7.68471Z",
    fill: "#844D9E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0.12793 7.68471V25.9314C0.12793 32.724 7.12333 35.4074 11.2335 35.4074V5.79871C9.99522 5.38811 8.69257 5.18072 7.38122 5.18537C4.72694 5.16585 2.15334 6.05266 0.12793 7.68471Z",
    fill: "url(#paint1_linear_3411_2017)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M21.1947 22.5733C23.1901 21.9255 24.9399 20.7315 26.2246 19.1412C27.5093 17.5508 28.2715 15.6349 28.4158 13.6339C28.6414 5.06261 21.9684 0.0332795 13.9092 0.0332795C11.104 0.0247442 8.34763 0.731378 5.92683 2.07968C3.50602 3.42798 1.50919 5.36869 0.144043 7.69995C2.16027 6.04575 4.73483 5.13684 7.39733 5.13928C8.70869 5.13462 10.0113 5.34202 11.2496 5.75261C13.2365 6.41109 14.9468 7.66227 16.1259 9.31994C17.3051 10.9776 17.89 12.9532 17.7937 14.9526C17.7302 16.5806 17.2581 18.1706 16.4169 19.5897C15.5756 21.0087 14.3898 22.2158 12.9582 23.1099C15.7075 23.5923 18.5402 23.4078 21.1947 22.5733Z",
    fill: "#844D9E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M39.1668 35.4839C41.7929 35.4839 43.9217 33.4588 43.9217 30.9606C43.9217 28.4624 41.7929 26.4373 39.1668 26.4373C36.5407 26.4373 34.4119 28.4624 34.4119 30.9606C34.4119 33.4588 36.5407 35.4839 39.1668 35.4839Z",
    fill: "#5759A7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3411_2017",
    x1: 31.9224,
    y1: 31.4358,
    x2: 22.5591,
    y2: 14.5154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#7F7D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3A3738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3411_2017",
    x1: 5.91072,
    y1: 28.6228,
    x2: 5.33845,
    y2: -6.52089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BAB9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#6C696A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#231F20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoziePurpleBlueLogo);
export default __webpack_public_path__ + "static/media/Rozie-PurpleBlue-Logo .798e1e0f93b2c5e8dfcd94999846f968.svg";
export { ForwardRef as ReactComponent };